
export default {
    getPublisher(params) {
        let path = process.env.apiPath + '/publisher/publisher.get';
        params = params || 'publisher.account,publisher.payment_details,publisher.rank,publisher_payment_details.created_at,publisher_payment_details.updated_at,publisher.subscribed,publisher.contact';
        return this.makeRequest(path, params);
    },

    getPublisherRanks() {
        let path = process.env.apiPath + '/publisher/publisher.getPublisherRanks';
        return this.makeRequest(path, { queryMethod: 'GET' });
    },

    editPublisher(params) {
        let path = process.env.apiPath + '/publisher/publisher.edit';
        params = params || '';
        return this.makeRequest(path, params);
    },

    getReport(params) {
        let path = process.env.apiPath + '/publisher/report.get';
        params = params || {};
        params.isAdvertiser = 1;
        return this.makeRequest(path, params);
    },

    searchPayouts(params) {
        let path = process.env.apiPath + '/publisher/publisherPayouts.search';
        params = params || {};
        params.fields = params.fields || 'publisher_payout.created_at,publisher_payout.sum_original,publisher_payout.payment_method_details,publisher_payout.fee,publisher_payout.comment,publisher_payout.from_dt';
        return this.makeRequest(path, params);
    },

    searchAdvertisers(params) {
        let path = process.env.apiPath + '/publisher/advertisers.search';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchPeriods(params) {
        let path = process.env.apiPath + '/publisher/periods.search';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchPublisher(params) {
        let path = process.env.apiPath + '/publisher/publisher.search';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchCreativeType(params) {
        let path = process.env.apiPath + '/publisher/creativeType.search';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchCreativeLink(params) {
        let path = process.env.apiPath + '/publisher/creativeLink.search';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchCreativeContainer(params) {
        let path = process.env.apiPath + '/publisher/creativeContainer.search';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchCreativeBanner(params) {
        let path = process.env.apiPath + '/publisher/creativeBanner.search';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchCreativeLanding(params) {
        let path = process.env.apiPath + '/publisher/creativeLanding.search';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchCreativePromoCode(params) {
        let path = process.env.apiPath + '/publisher/creativePromoCode.search';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchLinks(params) {
        let path = process.env.apiPath + '/publisher/links.search';
        params = params || {};
        params.fields = 'link.url,link.offer,link.default,link.selfie_link,link.locales,offer.advertiser,offer.locales,link.image,link.thumbnail';
        return this.makeRequest(path, params);
    },

    searchGoals(params) {
        let path = process.env.apiPath + '/publisher/goals.search';
        params = params || {};
        params.fields = 'goal.offer,offer.advertiser,offer.default_link';
        return this.makeRequest(path, params);
    },

    convertCurrentCurrency(params) {
        let path = process.env.apiPath + '/publisher/publisherAccount.convert';
        params = params || '';
        return this.makeRequest(path, params);
    },

    testPostbacks(params) {
        let path = process.env.apiPath + '/publisher/publisherPostbacks.test';
        params = params || '';
        return this.makeRequest(path, params);
    },

    searchConversions(params) {
        let path = process.env.apiPath + '/publisher/conversions.search';
        params = params || {};
        params.isAdvertiser = 1;
        params.fields = 'conversion.adv_cid,conversion.currency_ratio,conversion.track,currency_ratio.rates,commission.contract,commission.sale_sum,commission.promotion_personal_percent,commission.promotion_per_lead,commission.promotion_per_sale,track.request,track.created_at,track_request.region,track_request.ip,track_request.device';
        return this.makeRequest(path, params);
    },

    searchConversionTotalRows(params) {
        let path = process.env.apiPath + '/publisher/conversions.totalRows';
        params = params || {};

        return this.makeRequest(path, params);
    },

    searchFinanceOperations(params) {
        let path = process.env.apiPath + '/publisher/financeOperations.search';
        params = params || {};
        params.fields = '';
        return this.makeRequest(path, params);
    },

    getContactTypes() {
        let path = process.env.apiPath + '/publisher/publisher.getContactTypes';
        return this.makeRequest(path, { queryMethod: 'GET' });
    },

    getNotification() {
        let path = process.env.apiPath + '/publisher/notification.get';
        return this.makeRequest(path);
    },

    getAggregationInfo() {
        let path = process.env.apiPath + '/publisher/aggregationInfo.get';
        return this.makeRequest(path);
    },

    getConversionUserInfo(params) {
        let path = process.env.apiPath + '/publisher/conversionUserInfo.get';
        params = params || {};
        return this.makeRequest(path, params);
    },

    saveViewNotification(params) {
        let path = process.env.apiPath + '/publisher/notification.saveView';
        return this.makeRequest(path, params);
    },

    searchInfoDocs(params) {
        let path = process.env.apiPath + '/publisher/promo.search';
        return this.makeRequest(path, params);
    },

    saveLinkPresets(params) {
        let path = process.env.apiPath + '/publisher/links.savePresets';
        params = params || {};
        return this.makeRequest(path, params);
    },

    savePromoCode(params) {
        let path = process.env.apiPath + '/publisher/promo_code.save';
        params = params || {};
        return this.makeRequest(path, params);
    },

    editPromoCode(params) {
        let path = process.env.apiPath + '/publisher/promo_code.edit';
        params = params || {};
        return this.makeRequest(path, params);
    },

    deletePromoCode(params) {
        let path = process.env.apiPath + '/publisher/promo_code.delete';
        params = params || {};
        return this.makeRequest(path, params);
    }
};
